/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutReleasePolicyPathParams = NonNullable<operations['PutReleasePolicy']['parameters']['path']>;

export type PutReleasePolicyRequestBody = OperationRequestBodyContent<operations['PutReleasePolicy']>;

export interface Input extends PutReleasePolicyPathParams {
  apiVersion?: string;
  body: PutReleasePolicyRequestBody;
  header: NonNullable<operations['PutReleasePolicy']['parameters']['header']>;
}

export async function PutReleasePolicy(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/release-policies/{policyKey}', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
